export default (fieldValue,fieldName,label) => {
    
    var re = /^.{8,12}$/;
    return {
      valid: fieldValue != null ? re.test(fieldValue) : true,
      validationText: "חובה להזין ערך מעל ל 8 תוים ומתחת ל 12 "
    };
  };
  